export enum PaymentType {
  ADD_SEATS = 'seats_added',
  CHANGE_RECURRENCE = 'recurrence_changed',
  REACTIVATION = 'subscription_reactivated',
  RETRY_PAYMENT = 'retry_payment',
  SUBSCRIPTION = 'new_subscription',
  UPGRADE = 'plan_upgraded',
  TRIAL_ACTIVATED = 'trial_activated',
}
